import { useCallback } from 'react';
import { useAction } from '@wix/da-hooks/pkg/useAction';
import { getDeviationType } from '../../../DeviationViews/_helpers';
import { DeviationTypes } from '../../../types/deviation';
import { deleteTier } from '../../../Tier/redux/creator/actions';
import { deleteDeviation } from '../../../redux/deviations/actionCreators';
/**
 * Dispatches the appropriate delete action for a deviation type. The returned callback should only be
 * called when we're ready to REALLY delete the deviation. There is no confirmation step baked in.
 */ export function useDeleteDeviationAction() {
    const dispatchDeleteDeviation = useAction(deleteDeviation);
    const dispatchDeleteTier = useAction(deleteTier);
    return useCallback((payload)=>{
        if (getDeviationType(payload.deviation) === DeviationTypes.TIER) {
            dispatchDeleteTier(payload.deviation, undefined);
        } else {
            dispatchDeleteDeviation(payload);
        }
    }, [
        dispatchDeleteDeviation,
        dispatchDeleteTier
    ]);
}

//# sourceMappingURL=useDeleteDeviationAction.js.map